import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

const checkmarkCircleFilledVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
      primary: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type CheckmarkCircleFilledProps = {
  width?: string | number;
  height?: string | number;
  viewBox?: string;
  fill?: string;
} & React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof checkmarkCircleFilledVariants>;

const CheckmarkCircleFilled = React.forwardRef<
  SVGSVGElement,
  CheckmarkCircleFilledProps
>(
  (
    {
      className,
      variant,
      viewBox,
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        className={cn(
          checkmarkCircleFilledVariants({
            variant,
            className,
          }),
        )}
        fill={fill}
        height={height}
        ref={ref}
        viewBox={viewBox ?? '0 0 24 24'}
        width={width}
        {...props}
      >
        <path d="M12 2.40002C14.5461 2.40002 16.9879 3.41145 18.7882 5.2118C20.5886 7.01215 21.6 9.45395 21.6 12C21.6 14.5461 20.5886 16.9879 18.7882 18.7882C16.9879 20.5886 14.5461 21.6 12 21.6C9.45392 21.6 7.01212 20.5886 5.21178 18.7882C3.41143 16.9879 2.4 14.5461 2.4 12C2.4 9.45395 3.41143 7.01215 5.21178 5.2118C7.01212 3.41145 9.45392 2.40002 12 2.40002ZM16.0296 9.17522C15.9302 9.07632 15.7994 9.01532 15.6598 9.00283C15.5201 8.99033 15.3805 9.02713 15.2652 9.10682L15.1812 9.17522L10.8 13.5576L8.8248 11.5812L8.7408 11.5116C8.62522 11.432 8.48539 11.3954 8.34562 11.4082C8.20586 11.421 8.07501 11.4825 7.97584 11.5818C7.87667 11.6811 7.81545 11.812 7.80284 11.9518C7.79022 12.0916 7.82701 12.2314 7.9068 12.3468L7.9752 12.4308L10.3752 14.8308L10.4592 14.8992C10.5594 14.9684 10.6783 15.0054 10.8 15.0054C10.9217 15.0054 11.0406 14.9684 11.1408 14.8992L11.2248 14.8296L16.0296 10.0248L16.0992 9.94082C16.1791 9.82525 16.2158 9.68532 16.2031 9.54541C16.1904 9.40551 16.129 9.2745 16.0296 9.17522Z" />
      </svg>
    );
  },
);

CheckmarkCircleFilled.displayName = 'CheckmarkCircleFilled';

export { CheckmarkCircleFilled, checkmarkCircleFilledVariants };
